// extracted by mini-css-extract-plugin
export default {"segment":"section_segment__gt94t","headerRow":"section_headerRow__0FrWv","messageWithTooltip":"section_messageWithTooltip__UBp5p"};